import type { DesktopWidths, BlockPaddingTops, BlockPaddingBottoms } from '#constants/types/storyblok';

export default function useVisualAppearancePlugin(props: any) {
  const desktopWidth = (defaultWidth: DesktopWidths = 'full') => {
    const userSelected = props.blok?.visualAppearance?.desktopWidth || '';
    if (userSelected === 'recommended' || userSelected === '') {
      return `desktopMaxW-${defaultWidth}`;
    }
    return `desktopMaxW-${userSelected}`;
  };

  const blockPaddingTop = (defaultPadding: BlockPaddingTops = 'md') => {
    const userSelected = props.blok?.visualAppearance?.blockPaddingTop || '';
    if (userSelected === 'recommended' || userSelected === '') {
      return `blockPaddingTop-${defaultPadding}`;
    }
    return `blockPaddingTop-${userSelected}`;
  };

  const blockPaddingBottom = (defaultPadding: BlockPaddingBottoms = 'md') => {
    const userSelected = props.blok?.visualAppearance?.blockPaddingBottom || '';
    if (userSelected === 'recommended' || userSelected === '') {
      return `blockPaddingBottom-${defaultPadding}`;
    }
    return `blockPaddingBottom-${userSelected}`;
  };

  return {
    desktopWidth,
    blockPaddingTop,
    blockPaddingBottom,
  };
}
